import React from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import WorkspaceChat from './WorkspaceChat';
import OrganizerHome from './OrganizerHome';
import Dashboard from './Dashboard';

export default function WorkspaceHome() {
  const { user } = useAuth();
  const location = useLocation();
  if (user?.role === 'admin' || new URLSearchParams(location.search).get('view') === 'overview') return <Dashboard />;
  if (user?.role === 'organizer' && new URLSearchParams(location.search).get('view') === 'projects') return <OrganizerHome />;
  return <WorkspaceChat key={user?.id} />;
}
